import React from 'react'
import secureIcon from '../../../../assets/CreditCheckOTP/img/secure-icon.png'
import succesTick from '../../../../assets/CreditCheckOTP/img/success-tick.gif'
const OTPSuccess = ({ show }) => {
    return (
        <>
            <div className={`all-screen screen4 otp-card p-4 ${show ? "show" : "hide"}`}>
                <div className="card-body text-white">
                    <img src={succesTick} className="img-fluid mt-4 mb-3 success-tick" alt="security-icon" />
                    <h3 className="text-center">OTP Verified Successfully</h3>
                    <p>Your OTP submission has been successfully completed.</p>
                    <div className="scure-logo m-auto">
                        <img src={secureIcon} style={{ height: 50 }} alt />
                    </div>
                </div>
            </div >

        </>
    )
}

export default OTPSuccess